<!--
 * @Author: your name
 * @Date: 2021-03-19 14:40:29
 * @LastEditTime: 2021-03-19 14:41:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \e6-module-park-management\src\e6-module-park-management\views\businessManagement\appointmentList\add.vue
-->
<template>
  <booking-edit pageType="store"></booking-edit>
</template>

<script>
import bookingEdit from "../components/bookingEdit";
export default {
  name: "storeBookingAdd",
  components: {
    bookingEdit
  }
};
</script>
